import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
import calcService from "data/calc"
// components
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
// lib
import api_match from 'data/interface/api'
import propertyService from 'data/property'
import rentrollService from 'data/rent-roll'
// styles
import { Label_s } from 'styles/app-styles'
import DataTable_s from 'components/table/data-table-styles'
import { TenantGrid_s } from 'components/property/reports/report-styles'

interface TenantGridProps {
  selected: number[],
  setSelected: Function
}

const TenantGrid: FC<TenantGridProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())

  useEffect(() => {
    const rentRollSubscription = rentrollService.stream().subscribe(data => {
      api_match(
        data,
        init  => {
          setData(_.sortBy(init.value, ['sortorder']));
          props.setSelected(init.value);
        },
        ok    => {
          setData(_.sortBy(ok.value, ['sortorder']));
          props.setSelected(ok.value);
        },
        err   => {
          setData(err.value)
        },
        fetch => {}
      )
    })
    return function cleanup() {
      rentRollSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    setPropertyId(propertyService.getStoredPropertyId());
    if (_.isNil(propertyId)) return
    rentrollService.fetchRentRoll(propertyService.getStoredPropertyId())
  }, [propertyService.getStoredPropertyId()])

  return (
    <TenantGrid_s>
      <Label_s>Tenants</Label_s>
      <DataTable_s>
        <DataTable
          value={data}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          emptyMessage="No records found"
          selection={props.selected}
          onSelectionChange={(e)=>props.setSelected(e.value)}
        >
          <Column selectionMode="multiple" style={{width: '20px'}} />
          <Column header="Sort Order" field="sortorder" sortable={true} style={{width: '100px'}} />
          <Column field="suite" header="Suite" sortable={true} style={{width: '180px'}} />
          <Column field="tenant" header="Name" sortable={true} style={{width: '225px'}} />
        </DataTable>
      </DataTable_s>
    </TenantGrid_s>
  )
}

export default TenantGrid
